import { AsyncSelectInputSingle } from '@frontend/basic-forms';

import useContactSelect from './contact-select.controller';

const ID = 'contact-select';
export interface ContactSelectProps {
    id?: string;
    label?: string;
    required?: boolean;
    submitted: boolean;
    onChange: (newValue?: string) => void;
    value?: string;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
}

const ContactSelect = (props: ContactSelectProps) => {
    const viewProps = useContactSelect(props);

    return (
        <AsyncSelectInputSingle
            id={props.id || ID}
            required={props.required}
            label={props.label || 'Contact'}
            className={props.className}
            submitted={props.submitted}
            options={viewProps.options}
            onChange={(newValue) => props.onChange(newValue?.value)}
            value={viewProps.value?.value}
            isDisabled={props.disabled}
            onMenuScrollToBottom={viewProps.onScrollToBottom}
            loadOptions={viewProps.search}
            isClearable={props.isClearable}
            useConditionedStyling={props.useConditionedStyling}
        />
    );
};

export default ContactSelect;
